export const buildRankingTableSections = ({
  aroundDisplayCount,
  maxDisplayCount,
  ranking,
  topDisplayCount,
}) => {
  const totalCount = Number(ranking?.totalCount ?? 0);
  const currentUserRank = Number(ranking?.currentUserRank);

  if (totalCount <= maxDisplayCount) {
    return [{
      displayCount: totalCount,
      displayMode: 'top',
      key: 'all',
    }];
  }

  if (Number.isFinite(currentUserRank) && currentUserRank > 0 && currentUserRank <= maxDisplayCount) {
    return [{
      displayCount: maxDisplayCount,
      displayMode: 'top',
      key: 'top',
    }];
  }

  if (!Number.isFinite(currentUserRank) || currentUserRank <= 0) {
    return [{
      displayCount: maxDisplayCount,
      displayMode: 'top',
      key: 'top-fallback',
    }];
  }

  return [
    {
      displayCount: topDisplayCount,
      displayMode: 'top',
      key: 'top',
      title: '上位ランキング',
    },
    {
      key: 'separator',
      separator: true,
    },
    {
      displayCount: aroundDisplayCount,
      displayMode: 'aroundMe',
      key: 'around-me',
      title: '現在ユーザー周辺',
    },
  ];
};
